"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScreenShotInfo = void 0;
/**
 * 获取到截屏页面的图片信息
 */
var request_1 = require("./request");
var getScreenShotInfo = function (props) {
    var config = props.config, requestUrl = props.requestUrl, needPrefix = props.needPrefix;
    // 返回一个promise对象
    return new Promise(function (resolve, reject) {
        var type = config.type, quality = config.quality, fullPage = config.fullPage, encoding = config.encoding, ohterConfig = __rest(config, ["type", "quality", "fullPage", "encoding"]);
        var params = __assign(__assign({}, ohterConfig), { url: ohterConfig.url || window.location.href, picOption: {
                encoding: encoding || 'base64',
                fullPage: !ohterConfig,
                type: type || 'jpeg',
                // 只有在jpeg的时候生效
                quality: quality || 70
            } });
        request_1.request(requestUrl || '//feserver.58che.com/screenshot', __assign({}, params), 'json', {
            method: 'post',
            isCors: true
        }).then(function (res) {
            if (res.code === 1) {
                var _a = res.data, type_1 = _a.type, base64 = _a.base64;
                var base64Prefix = "data:image/" + type_1 + ";base64,";
                var base64Url = needPrefix === false ? base64 : "" + base64Prefix + base64;
                resolve(base64Url);
            }
            else {
                reject(res.message);
            }
        });
    });
};
exports.getScreenShotInfo = getScreenShotInfo;
